import { UndoRedo } from '@tiptap/extensions'
import { HistoryActionButton } from '@/tiptap/extensions/components/ActionButton'

export const History = UndoRedo.extend({
  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      depth: 10,
      button: ({ editor, t }) => ({
        component: HistoryActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },
})

export default History
